import api from "./api";

// ==================== BOARD SERVICES ====================

export const listBoards = (params) => {
  return api.get("/kanban/boards", { params });
};

export const createBoard = (data) => {
  return api.post("/kanban/boards", data);
};

export const showBoard = (boardId) => {
  return api.get(`/kanban/boards/${boardId}`);
};

export const updateBoard = (boardId, data) => {
  return api.put(`/kanban/boards/${boardId}`, data);
};

export const reorderBoards = (boards) => {
  return api.put("/kanban/boards/reorder", { boards });
};

export const deleteBoard = (boardId) => {
  return api.delete(`/kanban/boards/${boardId}`);
};

export const seedDefaultBoards = (boardName) => {
  return api.post("/kanban/boards/seed-defaults", boardName ? { boardName } : {});
};

export const getBoardTemplates = () => {
  return api.get("/kanban/boards/templates");
};

// ==================== COLUMN SERVICES ====================

export const createColumn = (data) => {
  return api.post("/kanban/columns", data);
};

export const updateColumn = (columnId, data) => {
  return api.put(`/kanban/columns/${columnId}`, data);
};

export const deleteColumn = (columnId) => {
  return api.delete(`/kanban/columns/${columnId}`);
};

export const clearColumn = (columnId) => {
  return api.delete(`/kanban/columns/${columnId}/clear`);
};

export const reorderColumns = (boardId, columns) => {
  return api.put(`/kanban/boards/${boardId}/columns/reorder`, { columns });
};

// ==================== CARD SERVICES ====================

export const createCard = (data) => {
  return api.post("/kanban/cards", data);
};

export const updateCard = (cardId, data) => {
  return api.put(`/kanban/cards/${cardId}`, data);
};

export const deleteCard = (cardId) => {
  return api.delete(`/kanban/cards/${cardId}`);
};

export const moveCard = (cardId, data) => {
  return api.put(`/kanban/cards/${cardId}/move`, data);
};

export const reorderCards = (columnId, cards) => {
  return api.put(`/kanban/columns/${columnId}/cards/reorder`, { cards });
};

export const listRelatedCards = (cardId) => {
  return api.get(`/kanban/cards/${cardId}/related`);
};

// Cards já existentes do contato, no escopo configurado pelo admin
// (Configurações > Kanban). Retorna { mode, scope, cards }.
export const listCardsByContact = (contactId, params) => {
  return api.get(`/kanban/cards/contact/${contactId}`, { params });
};

export const searchCardsAPI = (params) => {
  return api.get("/kanban/cards/search", { params });
};

// ==================== INTEGRACAO SERVICES ====================

// Busca imobilizados da empresa na empsis (alimenta os campos de patrimônio dos
// boards de locação). O filtro roda no servidor: `searchParam` é o que o usuário
// digitou (mínimo 3 letras) e `patrimonios` resolve, de uma vez, a descrição dos
// códigos já gravados no card. Falha na empsis devolve lista vazia, nunca erro.
export const getEmpsisImobilizados = ({ searchParam, patrimonios } = {}) => {
  const params = {};
  if (searchParam !== undefined) params.searchParam = searchParam;
  if (patrimonios && patrimonios.length) params.patrimonios = patrimonios.join(",");

  return api.get("/kanban/integracoes/empsis/imobilizados", { params });
};

// Valida o token da empsis consultando o imobilizado de verdade. Aceita um token
// avulso para conferir antes de salvar; sem ele usa o que está configurado.
export const testarConexaoEmpsis = (token) => {
  return api.post("/kanban/integracoes/empsis/imobilizados/testar", token ? { token } : {});
};

// ==================== CLIENTE SERVICES ====================

export const getClientes = (params) => {
  return api.get("/clientes", { params });
};

// ==================== CLIENTE COMMENT SERVICES ====================

export const listClienteComments = (clienteId, params = {}) => {
  return api.get(`/clientes/${clienteId}/comments`, { params });
};

export const createClienteComment = (clienteId, data) => {
  return api.post(`/clientes/${clienteId}/comments`, data);
};

export const updateClienteComment = (commentId, data) => {
  return api.put(`/clientes/comments/${commentId}`, data);
};

export const deleteClienteComment = (commentId) => {
  return api.delete(`/clientes/comments/${commentId}`);
};
